export default __webpack_public_path__ + "static/media/mountains.7e574efa.png";